import React, { useContext } from 'react';
import styled from 'styled-components';
import { BackgroundColorContext } from '@/features/editor/widgets/custom-widget/inputs/background/color/shared/context';
import { GradientSlider } from '@/features/editor/widgets/custom-widget/inputs/background/color/components/gradient-slider';
import {
  ColorPadding,
  Divider,
} from '@/features/editor/widgets/custom-widget/inputs/background/color/components/commons';
import { ColorSaturationPicker } from '@/features/editor/widgets/custom-widget/inputs/background/color/components/color-sat-picker';
import { ColorPreview } from '@/features/editor/widgets/custom-widget/inputs/background/color/components/color-preview';
import { ColorHuePicker } from '@/features/editor/widgets/custom-widget/inputs/background/color/components/color-hue-picker';
import { ColorAlphaPicker } from '@/features/editor/widgets/custom-widget/inputs/background/color/components/color-alpha-picker';
import { ColorFavoritesPicker } from '@/features/editor/widgets/custom-widget/inputs/background/color/components/fav-picker';
import {
  EyeDropper,
  useEyeDropProps,
} from '@/features/editor/widgets/custom-widget/inputs/background/color/eyeDropper';

export function RadialColorTab() {
  const {
    radialColor,
    radialFavourites,
    setRadialFavourites,
    updateRadialColor,
  } = useContext(BackgroundColorContext);
  const props = useEyeDropProps();

  return (
    <Wrapper>
      <GradientSlider />
      <Divider />
      <ControlsSection>
        <ColorSaturationPicker />
        <EyeDropper {...props} />
        <ControlsWrapper>
          <ColorPreview />
          <ColorHuePicker eyeDropColor={props.color} />
          <ColorAlphaPicker />
        </ControlsWrapper>
      </ControlsSection>
      <Divider />
      <ColorPadding>
        <ColorFavoritesPicker
          currentColor={radialColor}
          favorites={radialFavourites}
          setFavourites={setRadialFavourites}
          updateColor={updateRadialColor}
        />
      </ColorPadding>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 8rem 1px 1fr 1px 10rem;
`;

const ControlsSection = styled(ColorPadding)`
  && {
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: 2fr 30px 3fr;
    justify-content: center;
    grid-gap: 0.5rem;
  }
`;

const ControlsWrapper = styled.div`
  height: 100%;
  width: 100%;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  justify-content: center;
  align-items: flex-end;
`;
